webpackJsonp([50010302253903],{

/***/ 1686:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusHistoryEventEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"CensusHistoryEvent","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-census-history-event-edge-4c6cf14258bc9bb144b3.js